/**
 * A custom hook to track a value before it's updated. Returns a ref
 * to the previous value. Used like 'prevProps'.
 * https://usehooks.com/usePrevious/
 *
 * @param {Any} value The prop to watch for updates
 */

import {
    useEffect,
    useRef,
} from 'react';

const usePrevious = (value) => {

    const ref = useRef();

    useEffect(() => {

        ref.current = value;

    }, [value]);

    return ref.current;

};

export default usePrevious;
